// @flow
import $ from 'jquery'
import webfont from 'webfontloader'

export function tryCustomScripts (exec: Function) {
  try {
    exec()
  } catch (e) {
    console.warn('there was an error executing a custom script', e)
  }
}


export function coverIfInPreviewMode () {
  if (window.location.search.indexOf('previewMode=true') === -1) { return; }

  var body = $('body')
  var frameCover = $('<div class="iframe-cover">')

  body.css({
    position: 'relative'
  })

  frameCover.css({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
    zIndex: 1
  }).appendTo(body)
}

export function loadWebFonts (config: Object) {
  webfont.load(config)
}
